<template>
  <div id="app">
    <router-view />
    <CompanyUser /> <!-- -->
  </div>
</template>

<script>
import CompanyUser from "@/views/CompanyUser.vue";
export default {
  name: "App",
  components: {
    CompanyUser,
  },
  computed: {
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
</style>

